import Cookies from 'js-cookie'

const TokenKey = 'gczjtoken'
const UserInfoKey = 'aaa.userinfo'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function getUserInfo() {
  const userInfo = localStorage.getItem(UserInfoKey)
  return userInfo ? JSON.parse(userInfo) : null
}

export function setUserInfo(userInfo) {
  return localStorage.setItem(UserInfoKey, JSON.stringify(userInfo))
}

export function removeUserInfo() {
  return localStorage.removeItem(UserInfoKey)
}

// 检查是否已登录
export function isAuthenticated() {
  return !!getToken()
}

// 检查登录状态，如果未登录则提示并跳转登录页
export function checkAuth(router, message) {
  if (!isAuthenticated()) {
    if (message) {
      const { Message } = require('element-ui')
      Message.warning(message || '请先登录后再进行操作')
    }
    if (router) {
      router.push({
        path: '/login',
        query: { redirect: router.currentRoute.fullPath }
      })
    }
    return false
  }
  return true
}
